// extracted by mini-css-extract-plugin
module.exports = {"row":"SellersList_row__34trI","col":"SellersList_col__1DVgg","card":"SellersList_card__Wbe7G"};